import React from "react";
import { NavLink } from "react-router-dom";
import useSidebar from "../../../hooks/sidebar/useSidebar";

interface SearchResultItemProps {
  name: string;
  route: string;
  moduleCode: string; // 👈 agregado
  onClose: () => void;
}

/**
 * 🎯 SearchResultItem (sincronizado con Sidebar)
 *
 * - Usa `<NavLink>` para navegar.
 * - Antes de navegar, sincroniza el módulo activo en el Sidebar.
 * - Cierra el panel después de hacer clic.
 */
const SearchResultItem: React.FC<SearchResultItemProps> = ({
  name,
  route,
  moduleCode,
  onClose,
}) => {
  const { fetchModuleMenus } = useSidebar();

  const handleSelect = async () => {

    console.log(moduleCode);

    if (moduleCode) {
      await fetchModuleMenus(moduleCode);
    }
    onClose();
  };

  return (
    <li>
      <NavLink
        to={route}
        onClick={handleSelect}
        className={({ isActive }) =>
          `
          block px-5 py-3 cursor-pointer select-none truncate
          text-sm font-medium transition-colors duration-150
          ${
            isActive
              ? "bg-primary/10 text-primary font-semibold"
              : "hover:bg-primary/10 hover:text-primary"
          }
          dark:hover:bg-white/10
        `
        }
      >
        {name}
        {/* Ruta y módulo ocultos visualmente */}
        <span className="hidden">{route}</span>
        <span className="hidden">{moduleCode}</span>
      </NavLink>
    </li>
  );
};

export default SearchResultItem;
